import { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  description?: ReactNode;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionHeading({
  title,
  subtitle,
  description,
  align = 'center',
  light = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}
    >
      {subtitle && (
        <p
          className={`text-sm font-semibold uppercase tracking-wider mb-3 ${
            light ? 'text-primary-300' : 'text-primary-600'
          }`}
        >
          {subtitle}
        </p>
      )}
      <h2
        className={`heading-2 mb-4 ${
          light ? 'text-white' : 'text-charcoal-900'
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`text-body ${
            light ? 'text-charcoal-300' : 'text-charcoal-600'
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}
